import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Repeat, ExternalLink } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const TOOLS = [
  { key: 'siigo_pyme', name: 'Siigo Pyme → Auxiliar', desc: 'Convierte el auxiliar de Siigo Pyme por tercero', file: '/conversiones/siigo_pyme.html' },
  { key: 'conversor_dian', name: 'Conversor DIAN', desc: 'Conversión por tipo de documento (exógena)', file: '/conversiones/conversor_dian.html' },
  { key: 'liquidador_rst', name: 'Liquidador RST', desc: 'Liquidación Régimen Simple de Tributación', file: '/conversiones/liquidador_rst.html' },
  { key: 'causacion_siigo', name: 'Causación Siigo CC-9', desc: 'Causación de compras para Siigo', file: '/conversiones/causacion_siigo.html' },
  { key: 'cartera_contado', name: 'Cartera de Contado', desc: 'Libro auxiliar 1305 de Siigo · cruce Factura ↔ Recibo de caja', file: '/conversiones/cartera_contado.html' },
];

export default function Conversiones() {
  const { user } = useAuth();
  const [active, setActive] = useState(TOOLS[0].key);

  if (user && user.role !== 'Administrador' && !user.acceso_conversiones) {
    return <Navigate to="/dashboard" replace />;
  }

  const tool = TOOLS.find((t) => t.key === active);

  return (
    <div className="space-y-5" data-testid="conversiones-page">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-slate-900 flex items-center gap-2" style={{ fontFamily: 'Outfit' }}>
            <Repeat className="w-6 h-6 text-[#1F3864]" /> Conversiones
          </h1>
          <p className="text-sm text-slate-500 mt-1">Herramientas de conversión y liquidación. Los archivos se procesan en tu navegador.</p>
        </div>
        <a
          href={tool.file}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-1.5 text-xs font-medium text-[#1F3864] hover:underline whitespace-nowrap"
          data-testid="conversiones-open-new-tab"
        >
          <ExternalLink className="w-3.5 h-3.5" /> Abrir en nueva pestaña
        </a>
      </div>

      <div className="flex gap-1 border-b border-slate-200 overflow-x-auto" data-testid="conversiones-tabs">
        {TOOLS.map((t) => (
          <button
            key={t.key}
            onClick={() => setActive(t.key)}
            className={`px-4 py-2.5 text-sm font-medium whitespace-nowrap border-b-2 -mb-px transition-colors ${
              active === t.key
                ? 'border-[#1F3864] text-[#1F3864]'
                : 'border-transparent text-slate-500 hover:text-slate-800 hover:border-slate-300'
            }`}
            data-testid={`conversiones-tab-${t.key}`}
          >
            {t.name}
          </button>
        ))}
      </div>

      <p className="text-xs text-slate-500" data-testid="conversiones-tool-desc">{tool.desc}</p>

      <div className="bg-white border border-slate-200 rounded-xl shadow-sm overflow-hidden" style={{ height: 'calc(100vh - 290px)', minHeight: 600 }}>
        <iframe
          key={tool.key}
          src={`${tool.file}?api=${encodeURIComponent(BACKEND_URL)}`}
          title={tool.name}
          className="w-full h-full border-0"
          data-testid={`conversiones-iframe-${tool.key}`}
        />
      </div>
    </div>
  );
}
